import { Link } from "react-router-dom";
import { ArrowUpRight, Clock } from "lucide-react";

export default function ArticleCard({ article, compact = false }) {
  return (
    <Link to={`/learning-center/${article.slug}`} className="card-editorial group block" data-testid={`article-card-${article.slug}`}>
      <div className={`relative overflow-hidden ${compact ? "aspect-[4/3]" : "aspect-[16/10]"}`}>
        <img src={article.image} alt={article.title} loading="lazy"
             className="h-full w-full object-cover transition-transform duration-1000 group-hover:scale-[1.05]" />
      </div>
      <div className="p-6">
        <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.2em] text-altura-gold-dark">
          <span>{article.category}</span>
          <span className="h-1 w-1 rounded-full bg-altura-gold-dark/40" />
          <span className="inline-flex items-center gap-1"><Clock className="h-3 w-3" />{article.reading_time}</span>
        </div>
        <h3 className="mt-3 font-editorial text-2xl text-altura-espresso leading-tight line-clamp-2">{article.title}</h3>
        <p className="mt-2 text-sm text-altura-charcoal/70 leading-relaxed line-clamp-3">{article.excerpt}</p>
        <div className="mt-5 inline-flex items-center gap-1.5 text-sm text-altura-espresso group-hover:text-altura-gold transition-colors">
          Read the essay <ArrowUpRight className="h-4 w-4" />
        </div>
      </div>
    </Link>
  );
}
